import React from 'react'

import { Home } from '../../../containers/Home'

export function HomeInit () {
  return <Home />
}
